module.exports = __webpack_public_path__ + "img/QR-code1.2bb14959.png";